import { Skeleton } from '@chakra-ui/react';
import GabStatus from '@Modules/terminalManagementSystem/gabManagement/components/GabStatus';
import { createColumnHelper } from '@tanstack/react-table';

export type T_TerminalsMonitoring = {
  primaryKey: string | number,
  state: boolean,
  number: string,
  name: string,
};

type Props = {
  isTerminalsMonotoringLoading: boolean | undefined,
};

const columnHelper = createColumnHelper<T_TerminalsMonitoring>();

export function getTerminalsMonitoringDataTableColumns({
  isTerminalsMonotoringLoading,
}: Props) {
  return [
    columnHelper.accessor('state', {
      id: 'state',
      header: '',
      cell: (props) => {
        return <Skeleton isLoaded={!isTerminalsMonotoringLoading}><GabStatus status={props.getValue()} /></Skeleton>;
      },
    }),
    
    columnHelper.accessor('number', {
      id: 'number',
      header: 'Num.',
      cell: (props) => {
        return <Skeleton isLoaded={!isTerminalsMonotoringLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('name', {
      id: 'name',
      header: 'Nom',
      cell: (props) => {
        return <Skeleton isLoaded={!isTerminalsMonotoringLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
  ];
}
